import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { CheckCircle, RotateCcw, LayoutDashboard } from "lucide-react";

const PartAddedSuccess = ({ addedPartName, onAddAnother, onGoToDashboard, isSubmitting }) => {
  return (
    <motion.div
      className="flex flex-col items-center justify-center space-y-6 bg-card p-4 md:p-8 rounded-xl shadow-2xl border border-border/20 text-center"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, type: "spring" }}
    >
      <CheckCircle className="w-10 h-10 md:h-16 md:w-16 text-green-500" />
      <h2 className="text-[21px] md:text-2xl font-semibold">Part Added Successfully!</h2>
      <p className="text-muted-foreground">"{addedPartName}" is now in your inventory.</p>
      <div className="flex flex-col sm:flex-row gap-4 pt-4 w-full xs:w-auto whitespace-nowrap">
        <Button
          onClick={onAddAnother}
          className="w-full xs:w-auto bg-gradient-to-r from-primary via-purple-600 to-accent text-primary-foreground hover:opacity-90 transition-opacity"
          disabled={isSubmitting}
        >
          <RotateCcw className="mr-2 h-4 w-4" /> Add Another Part
        </Button>
        <Button onClick={onGoToDashboard} variant="outline" className="w-full xs:w-auto" disabled={isSubmitting}>
          <LayoutDashboard className="mr-2 h-4 w-4" /> Go to Dashboard
        </Button>
      </div>
    </motion.div>
  );
};

export default PartAddedSuccess;
